<template>
  <div class="row">
    <template v-if="contentLoaded">
      <!-- KPIS -->
      <div v-for="kpi in kpis" class="col-sm-12 col-md-6 col-lg-3">
        <component :key="kpi.id" v-bind:is="kpi.name" v-bind="kpi.props"></component>
      </div>

      <!-- KBI -->
      <div class="col-sm-12 col-md-6 col-lg-3">
        <component :key="kbi.id" v-bind:is="kbi.name" v-bind="kbi.props"></component>
      </div>

      <!-- Meetings -->
      <div class="col-md-12 col-lg-6">
        <component :key="meeting.id" v-bind:is="meeting.name" v-bind="meeting.props"></component>
      </div>

      <!-- Actions -->
      <div class="col-md-12 col-lg-6">
        <component :key="action.id" v-bind:is="action.name" v-bind="action.props"></component>
      </div>
    </template>
    <div v-show="!contentLoaded" id="loading-icon-container">
      <div id="loading-icon-div">
        <img id="loading-icons" src="../assets/img/loading-icon.svg"/>
        <div id="loading-text">Dashboard is loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
  import apiHelper from "../mixins/APIHelper";
  import KPIWidget from "./KPIWidget.vue";
  import KBIWidget from "./KBIWidget.vue";
  import MeetingWidget from "./MeetingWidget";
  import ActionWidget from "./ActionsWidget";
  import PerformanceWidget from "./PerformanceWidget";
  import KpiDetailsModal from "./KpiDetailsModal";

  export default {
    components: {
      "kpi-widget": KPIWidget,
      "meeting-widget": MeetingWidget,
      "action-widget": ActionWidget,
      "kbi-widget": KBIWidget,
      "performance-widget": PerformanceWidget,
      "kpi-details-modal": KpiDetailsModal
    },
    name: "dashboard",
    data: function() {
      return {
        dashboardData: [],
        meeting: Object,
        action: Object,
        kpis: [],
        kbi: Object,
        content: Object,
        contentLoaded: false
      }
    },
    created() {
      this.getDashboard();
    },
    methods: {
      // Grabs all the data for the dashboard
      getDashboard: function () {
        let vm = this;
        apiHelper.getResource("/api/user/{uid}/dashboard").then((data) => {
          vm.dashboardData = data;
          this.selectWidgets(data);
          vm.contentLoaded = true;
        });
      },

      // Select the widget widgets
      selectWidgets(dashboard_data) {
        let vm = this;
        // Loops over the widgets and selects the good names for them
        for (let widget in dashboard_data) {

          switch (widget) {
            case 'content':
              let content_props = {"data" : dashboard_data[widget]};
              vm.content = {'name': 'content-widget', 'id': widget, 'props': content_props};
              break;
            case 'kbis':
              let kbi_props = {"data_kbi" : dashboard_data[widget]};
              vm.kbi = {'name': 'kbi-widget', 'id' : widget, 'props' : kbi_props};
              break;
            case 'meetings':
              let meeting_props = {"data" : dashboard_data[widget]};
              vm.meeting = {'name': 'meeting-widget', 'id' : widget, 'props' : meeting_props};
              break;
            case 'actions':
              let action_props = {"data" : dashboard_data[widget]};
              vm.action = {'name': 'action-widget', 'id' : widget, 'props' : action_props};
              break;
            case 'kpis':
              vm.kpis = [];
              for (let kpi in dashboard_data[widget]) {
                let kpi_props = {"kpi-data" : dashboard_data[widget][kpi]};
                vm.kpis.push({'name': 'kpi-widget', 'id' : kpi, 'props' : kpi_props});
              }
              break;
          }
        }
      }
    }
  }
</script>

<style scoped>
  #loading-icon-div{
    width: 200px;
  }
  #loading-text{
    text-align: center;
    margin-bottom: 4px;
  }
  #loading-icon-container{
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    display:flex;
    justify-content:center;
    align-items:center;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue